module.exports = __webpack_public_path__ + "img/69_27.24dec6d3.png";